import { t as r } from "./to-absolute-index.js";
import { l as a } from "./length-of-array-like.js";
import { c as o } from "./create-property.js";
var t = Array,
  e = Math.max,
  i = function i(_i, m, s) {
    for (var l = a(_i), p = r(m, l), f = r(void 0 === s ? l : s, l), n = t(e(f - p, 0)), c = 0; p < f; p++, c++) o(n, c, _i[p]);
    return n.length = c, n;
  };
export { i as a };